function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import Accordion from '../accordion';
import DisclaimerItem from './item';
import Text from '../text';
import Title from '../title';

var Disclaimer = function Disclaimer(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      others = _objectWithoutProperties(_ref, ["active", "children", "className", "title"]);

  if (!children) return null;
  var classes = classNames('disclaimer-content subtitle', className, {
    'is-active': active
  });
  return React.createElement(Accordion, {
    className: "disclaimer"
  }, React.createElement(Accordion.Item, null, React.createElement(Accordion.Header, {
    className: "disclaimer-header",
    "is-grouped": true,
    toggleBox: "left",
    toggleBoxClass: "is-info"
  }, React.createElement(Title, {
    size: 6
  }, title)), React.createElement(Accordion.Body, null, React.createElement("div", _extends({
    className: classes
  }, others), children && typeof children.valueOf() === 'string' ? React.createElement(Disclaimer.Text, {
    content: children
  }) : children))));
};

Disclaimer.Item = DisclaimerItem;
Disclaimer.Text = Text;
Disclaimer.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  className: PropTypes.string,
  active: PropTypes.bool
};
export default withModifiers(Disclaimer);